import * as React from 'react';

import { Col, Form, Row, Switch, Popover } from 'antd';
import axios from 'axios';
import {
  Button,
  ButtonShape,
  Input,
  Notification,
  Space,
  Text,
  Select,
  SelectOption as Option,
} from 'farmhub-ui-core';
import styled, { css } from 'styled-components';

import { Action, Wrapper } from 'components';
import { PlusIcon, TelegramContactIcon, XIcon } from 'components/Icon';
import { theme } from 'styled';
import { TELEGRAM_BOT } from 'utils';

const WrapIconAndGroupID = styled.div`
  display: flex;
`;

const WrapTitleBaseInfor = styled.div`
  display: flex;
  align-items: center;
`;

const WrapInput = styled.div`
  display: flex;
  margin-bottom: 12px;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 0px 6px 6px 0px;
  }
`;

const WrapFormInputGroupID = styled.div`
  padding: 11px;
  border: 1px dashed ${props => props.theme.colors.border.main};
  width: fit-content;
  height: 290px;
  border-radius: 6px;
  //overflow: hidden;
  //overflow-y: scroll;
`;

const WrapListGroup = styled.div`
  display: flex;
  flex-direction: column;
  height: 176px;
  overflow: hidden;
  overflow-y: scroll;
`;

const CButton = styled(Button)`
  color: ${p => p.theme.colors.primary.main};
  background: none;
  border: none;
  height: 22px;
  padding: 0px;
  box-shadow: none !important;
  text-shadow: none !important;

  &:hover,
  &:focus {
    background: none;
    color: ${p => p.theme.colors.primary.main};
    box-shadow: none;
    text-shadow: none;
  }
`;

const WrapLineAddGroup = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 22px;
  font-size: ${props => props.theme.font.size.xs};
  padding: 5px 0px 10px 0px;
`;

const GroupItem = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 12px;
  padding: 13px;
  background-color: rgba(57, 181, 74, 0.1);
  border-radius: 6px;
  justify-content: space-between;
`;

const IconButtonStyles = css`
  background: transparent;
  border: 0px;

  &:hover,
  &:focus,
  &:active {
    background-color: transparent;
  }
`;

interface TelegramAppProps {
  form: any;
  onSetBodyUpdate: (e: any) => void;
  listTelegramGroup: any[];
  setListTelegramGroup: (e: any[]) => void;
}

export const TelegramApp = ({
  form,
  onSetBodyUpdate,
  listTelegramGroup,
  setListTelegramGroup,
}: TelegramAppProps): JSX.Element => {
  const [group, setGroup] = React.useState<any>({});
  const [listGroupID, setListGroupID] = React.useState<any[]>([]);
  const [url, setUrl] = React.useState<string>();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const addGroupID = e => {
    setIsSubmitting(true);
    const data = form.getFieldsValue('telegramURL');

    if (Object.keys(group).length > 0 && data?.telegramURL) {
      if (listTelegramGroup?.find(item => item?.id == group.id)) {
        Notification('warning', 'Mã nhóm đã tồn tại!');
      } else {
        setListGroupID([...listGroupID.filter(item => item.id != group.id)]);
        listTelegramGroup?.push(group);
        setListTelegramGroup(listTelegramGroup);

        setGroup({});
      }
    }

    setTimeout(() => {
      setIsSubmitting(false);
    }, 500);
  };

  const addGroupID1 = () => {
    setIsSubmitting(true);
    const data = form.getFieldsValue(['telegramURL', 'group']);

    if (data?.telegramURL && data?.group) {
      if (listTelegramGroup?.find(item => item?.id == group)) {
        Notification('warning', 'Mã nhóm đã tồn tại!');
      } else {
        setListGroupID([...listGroupID.filter(item => item.id != group.id)]);
        listTelegramGroup?.push(group);
        setListTelegramGroup(listTelegramGroup);

        setGroup({});
      }
    }
  };

  const onChange = (checked: boolean) => {
    form.setFieldsValue({ telegramStatus: checked });
  };

  React.useEffect(() => {
    const TeleteGramGroupIDData = async () => {
      setListGroupID([]);
      // 5341288725:AAGjHhy9OvtwUxwAmIUUPrSAvzCX-DiHv1w
      try {
        const { data } = await axios.get(`${TELEGRAM_BOT}${url}/getUpdates`);

        if (data.result.length > 0) {
          for (let i = 0; i < data.result.length; i++) {
            if (
              data.result[i]?.message &&
              data.result[i]?.message.chat.type == 'group' &&
              !listGroupID.find(
                item => item?.id == data.result[i].message.chat.id
              )
            ) {
              listGroupID.push({
                id: data.result[i].message.chat.id,
                name: data.result[i].message.chat.title,
                url,
              });
            } else if (
              data.result[i]?.my_chat_member &&
              data.result[i].my_chat_member.chat.type == 'group' &&
              !listGroupID.find(
                item => item?.id == data.result[i].my_chat_member.chat.id
              )
            ) {
              listGroupID.push({
                id: data.result[i].my_chat_member.chat.id,
                name: data.result[i].my_chat_member.chat.title,
                url,
              });
            }
          }
        }

        setListGroupID([...listGroupID]);
      } catch (e) {
        console.log(e);
      }
    };

    TeleteGramGroupIDData();
  }, [url]);

  const deleteGroupItem = index => {
    listTelegramGroup.splice(index, 1);
    setListTelegramGroup([...listTelegramGroup]);
  };

  React.useEffect(() => {
    if (listGroupID.length == 0) {
      form.setFieldsValue({ group: 'Mã nhóm' });
    }
  }, [listGroupID.length]);

  const content = (
    <ul style={{ margin: '0px', padding: '5px 15px' }}>
      <li>Tạo bot bằng @BotFather - Telegram</li>
      <li>Cấp quyền và thêm bot và nhóm cần nhận thông báo</li>
      <li>chọn `/start` để bật bot</li>
      <li>Phát sinh tin nhắn trong nhóm `/start`</li>
      <li>Tạo link apiToken từ botFather sao chép và dán vào vị trí này</li>
    </ul>
  );

  return (
    <Form form={form} onValuesChange={onSetBodyUpdate}>
      <Wrapper style={{ padding: '0px' }}>
        <Row>
          <Col
            lg={6}
            sm={6}
            style={{ display: 'flex', alignItems: 'center' }}
            xs={24}
          >
            <Text>Hiển thị thông báo:</Text>
          </Col>
          <Col lg={18}>
            <Form.Item name="telegramStatus" style={{ marginBottom: '0px' }}>
              <Switch defaultChecked onChange={onChange} />
            </Form.Item>
          </Col>
        </Row>
        <Space height={30} />
        <Row>
          <Col lg={6} style={{ display: 'flex' }}>
            <Text>Danh sách kênh trò chuyện:</Text>
          </Col>

          <Col lg={18}>
            <WrapFormInputGroupID>
              <WrapInput>
                <Popover content={content} placement="bottom">
                  <Form.Item name="telegramURL" style={{ marginBottom: '0px' }}>
                    <Input
                      height={theme.input.height.md}
                      placeholder="Nhập đường dẫn Webhook"
                      styles={{ borderRadius: '6px 0px 0px 6px' }}
                      width="500px"
                      onChange={e => {
                        setUrl(e.target.value);
                        form.setFieldsValue({ telegramUrl: e.target.value });
                      }}
                    />
                  </Form.Item>
                </Popover>
                <Form.Item name="group" style={{ marginBottom: '0px' }}>
                  <Select
                    showSearch
                    height={theme.select.height.md}
                    placeholder="Mã nhóm"
                    styles={{
                      borderRadius: '0px 6px 6px 0px',
                      borderLeft: 'none',
                    }}
                    width="169px"
                    onChange={e => {
                      const data = listGroupID.find(item => item.id == e);
                      if (Object.keys(data).length > 0) {
                        setGroup(data);
                      }
                    }}
                  >
                    {listGroupID.length > 0 &&
                      (listGroupID || []).map((value: any) => (
                        <Option key={value.id} value={value.id}>
                          {value.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </WrapInput>

              <WrapLineAddGroup>
                <Text>Kênh nhận thông báo</Text>
                <CButton onClick={addGroupID}>
                  {' '}
                  <PlusIcon height={8} width={8} /> <Space width={3} /> Thêm mới
                </CButton>
              </WrapLineAddGroup>
              <WrapListGroup>
                {listTelegramGroup.length > 0 &&
                  listTelegramGroup?.map((item, index) => (
                    <GroupItem>
                      <WrapIconAndGroupID>
                        <TelegramContactIcon width={24} />

                        <Text
                          styles={{ marginLeft: '15px', maxWidth: '550px' }}
                        >
                          {item?.url}/{item?.name}
                        </Text>
                      </WrapIconAndGroupID>

                      <Action
                        buttonProps={{
                          shape: ButtonShape.Circle,
                          icon: {
                            children: <XIcon color="#F05540" width={18} />,
                          },
                          // width: '18px',
                          // height: '18px',
                          styles: IconButtonStyles,
                        }}
                        onClick={() => deleteGroupItem(index)}
                      />
                    </GroupItem>
                  ))}
              </WrapListGroup>
            </WrapFormInputGroupID>
          </Col>
        </Row>
      </Wrapper>
    </Form>
  );
};
